'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../settings-9ee2f03f.js');
var sharedComponents = require('../shared-components.js');
var _commonjsHelpers = require('../_commonjsHelpers-3fc1f64e.js');
require('../_react_commonjs-external-30e5c7b3.js');
require('../_prop-types_commonjs-external-c51b2bd5.js');
var number_format = require('../number_format-33e3898d.js');
var uaParser = require('../ua-parser-40543b9b.js');
var cloneDeep = _interopDefault(require('lodash/cloneDeep'));

var reactTagsinput = _commonjsHelpers.createCommonjsModule(function (module, exports) {
(function (global, factory) {
  {
    factory(module, exports, React__default, PropTypes$1);
  }
})(_commonjsHelpers.commonjsGlobal, function (module, exports, _react, _propTypes) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function uniq(arr) {
    var out = [];

    for (var i = 0; i < arr.length; i++) {
      if (out.indexOf(arr[i]) === -1) {
        out.push(arr[i]);
      }
    }

    return out;
  }

  /* istanbul ignore next */
  function getClipboardData(e) {
    if (window.clipboardData) {
      return window.clipboardData.getData('Text');
    }

    if (e.clipboardData) {
      return e.clipboardData.getData('text/plain');
    }

    return '';
  }

  function defaultRenderTag(props) {
    var tag = props.tag,
        key = props.key,
        disabled = props.disabled,
        onRemove = props.onRemove,
        classNameRemove = props.classNameRemove,
        getTagDisplayValue = props.getTagDisplayValue,
        other = _objectWithoutProperties(props, ['tag', 'key', 'disabled', 'onRemove', 'classNameRemove', 'getTagDisplayValue']);

    return _react2.default.createElement(
      'span',
      _extends({ key: key }, other),
      getTagDisplayValue(tag),
      !disabled && _react2.default.createElement('a', { className: classNameRemove, onClick: function onClick(e) {
          return onRemove(key);
        } })
    );
  }

  function defaultRenderInput(_ref) {
    var addTag = _ref.addTag,
        props = _objectWithoutProperties(_ref, ['addTag']);

    var onChange = props.onChange,
        value = props.value,
        other = _objectWithoutProperties(props, ['onChange', 'value']);

    return _react2.default.createElement('input', _extends({ type: 'text', onChange: onChange, value: value }, other));
  }

  function defaultRenderLayout(tagComponents, inputComponent) {
    return _react2.default.createElement(
      'span',
      null,
      tagComponents,
      inputComponent
    );
  }

  function defaultPasteSplit(data) {
    return data.split(' ').map(function (d) {
      return d.trim();
    });
  }

  var defaultInputProps = {
    className: 'react-tagsinput-input',
    placeholder: 'Add a tag'
  };

  var TagsInput = function (_React$Component) {
    _inherits(TagsInput, _React$Component);

    /* istanbul ignore next */
    function TagsInput() {
      _classCallCheck(this, TagsInput);

      var _this = _possibleConstructorReturn(this, (TagsInput.__proto__ || Object.getPrototypeOf(TagsInput)).call(this));

      _this.state = { tag: '', isFocused: false };
      _this.focus = _this.focus.bind(_this);
      _this.blur = _this.blur.bind(_this);
      return _this;
    }

    _createClass(TagsInput, [{
      key: '_getTagDisplayValue',
      value: function _getTagDisplayValue(tag) {
        var tagDisplayProp = this.props.tagDisplayProp;


        if (tagDisplayProp) {
          return tag[tagDisplayProp];
        }

        return tag;
      }
    }, {
      key: '_makeTag',
      value: function _makeTag(tag) {
        var tagDisplayProp = this.props.tagDisplayProp;


        if (tagDisplayProp) {
          return _defineProperty({}, tagDisplayProp, tag);
        }

        return tag;
      }
    }, {
      key: '_removeTag',
      value: function _removeTag(index) {
        var value = this.props.value.concat([]);
        if (index > -1 && index < value.length) {
          var changed = value.splice(index, 1);
          this.props.onChange(value, changed, [index]);
        }
      }
    }, {
      key: '_clearInput',
      value: function _clearInput() {
        if (this.hasControlledInput()) {
          this.props.onChangeInput('');
        } else {
          this.setState({ tag: '' });
        }
      }
    }, {
      key: '_tag',
      value: function _tag() {
        if (this.hasControlledInput()) {
          return this.props.inputValue;
        }

        return this.state.tag;
      }
    }, {
      key: '_addTags',
      value: function _addTags(tags) {
        var _this2 = this;

        var _props = this.props,
            validationRegex = _props.validationRegex,
            onChange = _props.onChange,
            onValidationReject = _props.onValidationReject,
            onlyUnique = _props.onlyUnique,
            maxTags = _props.maxTags,
            value = _props.value;


        if (onlyUnique) {
          tags = uniq(tags);
          tags = tags.filter(function (tag) {
            return value.every(function (currentTag) {
              return _this2._getTagDisplayValue(currentTag) !== _this2._getTagDisplayValue(tag);
            });
          });
        }

        var rejectedTags = tags.filter(function (tag) {
          return !validationRegex.test(_this2._getTagDisplayValue(tag));
        });
        tags = tags.filter(function (tag) {
          return validationRegex.test(_this2._getTagDisplayValue(tag));
        });
        tags = tags.filter(function (tag) {
          var tagDisplayValue = _this2._getTagDisplayValue(tag);
          if (typeof tagDisplayValue.trim === 'function') {
            return tagDisplayValue.trim().length > 0;
          } else {
            return tagDisplayValue;
          }
        });

        if (maxTags >= 0) {
          var remainingLimit = Math.max(maxTags - value.length, 0);
          tags = tags.slice(0, remainingLimit);
        }

        if (onValidationReject && rejectedTags.length > 0) {
          onValidationReject(rejectedTags);
        }

        if (tags.length > 0) {
          var newValue = value.concat(tags);
          var indexes = [];
          for (var i = 0; i < tags.length; i++) {
            indexes.push(value.length + i);
          }
          onChange(newValue, tags, indexes);
          this._clearInput();
          return true;
        }

        if (rejectedTags.length > 0) {
          return false;
        }

        this._clearInput();
        return false;
      }
    }, {
      key: '_shouldPreventDefaultEventOnAdd',
      value: function _shouldPreventDefaultEventOnAdd(added, empty, keyCode) {
        if (added) {
          return true;
        }

        if (keyCode === 13) {
          return this.props.preventSubmit || !this.props.preventSubmit && !empty;
        }

        return false;
      }
    }, {
      key: 'focus',
      value: function focus() {
        if (this.input && typeof this.input.focus === 'function') {
          this.input.focus();
        }

        this.handleOnFocus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        if (this.input && typeof this.input.blur === 'function') {
          this.input.blur();
        }

        this.handleOnBlur();
      }
    }, {
      key: 'accept',
      value: function accept() {
        var tag = this._tag();

        if (tag !== '') {
          tag = this._makeTag(tag);
          return this._addTags([tag]);
        }

        return false;
      }
    }, {
      key: 'addTag',
      value: function addTag(tag) {
        return this._addTags([tag]);
      }
    }, {
      key: 'clearInput',
      value: function clearInput() {
        this._clearInput();
      }
    }, {
      key: 'handlePaste',
      value: function handlePaste(e) {
        var _this3 = this;

        var _props2 = this.props,
            addOnPaste = _props2.addOnPaste,
            pasteSplit = _props2.pasteSplit;


        if (!addOnPaste) {
          return;
        }

        e.preventDefault();

        var data = getClipboardData(e);
        var tags = pasteSplit(data).map(function (tag) {
          return _this3._makeTag(tag);
        });

        this._addTags(tags);
      }
    }, {
      key: 'handleKeyDown',
      value: function handleKeyDown(e) {
        if (e.defaultPrevented) {
          return;
        }

        var _props3 = this.props,
            value = _props3.value,
            removeKeys = _props3.removeKeys,
            addKeys = _props3.addKeys;

        var tag = this._tag();
        var empty = tag === '';
        var keyCode = e.keyCode;
        var key = e.key;
        var add = addKeys.indexOf(keyCode) !== -1 || addKeys.indexOf(key) !== -1;
        var remove = removeKeys.indexOf(keyCode) !== -1 || removeKeys.indexOf(key) !== -1;

        if (add) {
          var added = this.accept();
          if (this._shouldPreventDefaultEventOnAdd(added, empty, keyCode)) {
            e.preventDefault();
          }
        }

        if (remove && value.length > 0 && empty) {
          e.preventDefault();
          this._removeTag(value.length - 1);
        }
      }
    }, {
      key: 'handleClick',
      value: function handleClick(e) {
        if (e.target === this.div) {
          this.focus();
        }
      }
    }, {
      key: 'handleChange',
      value: function handleChange(e) {
        var onChangeInput = this.props.onChangeInput;
        var onChange = this.props.inputProps.onChange;

        var tag = e.target.value;

        if (onChange) {
          onChange(e);
        }

        if (this.hasControlledInput()) {
          onChangeInput(tag);
        } else {
          this.setState({ tag: tag });
        }
      }
    }, {
      key: 'handleOnFocus',
      value: function handleOnFocus(e) {
        var onFocus = this.props.inputProps.onFocus;


        if (onFocus) {
          onFocus(e);
        }

        this.setState({ isFocused: true });
      }
    }, {
      key: 'handleOnBlur',
      value: function handleOnBlur(e) {
        var onBlur = this.props.inputProps.onBlur;


        this.setState({ isFocused: false });

        if (e == null) {
          return;
        }

        if (onBlur) {
          onBlur(e);
        }

        if (this.props.addOnBlur) {
          var tag = this._makeTag(e.target.value);
          this._addTags([tag]);
        }
      }
    }, {
      key: 'handleRemove',
      value: function handleRemove(tag) {
        this._removeTag(tag);
      }
    }, {
      key: 'inputProps',
      value: function inputProps() {
        var _props$inputProps = this.props.inputProps,
            onChange = _props$inputProps.onChange,
            onFocus = _props$inputProps.onFocus,
            onBlur = _props$inputProps.onBlur,
            otherInputProps = _objectWithoutProperties(_props$inputProps, ['onChange', 'onFocus', 'onBlur']);

        var props = _extends({}, defaultInputProps, otherInputProps);

        if (this.props.disabled) {
          props.disabled = true;
        }

        return props;
      }
    }, {
      key: 'inputValue',
      value: function inputValue(props) {
        return props.currentValue || props.inputValue || '';
      }
    }, {
      key: 'hasControlledInput',
      value: function hasControlledInput() {
        var _props4 = this.props,
            inputValue = _props4.inputValue,
            onChangeInput = _props4.onChangeInput;


        return typeof onChangeInput === 'function' && typeof inputValue === 'string';
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.hasControlledInput()) {
          return;
        }

        this.setState({
          tag: this.inputValue(this.props)
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        /* istanbul ignore next */
        if (this.hasControlledInput()) {
          return;
        }

        if (!this.inputValue(nextProps)) {
          return;
        }

        this.setState({
          tag: this.inputValue(nextProps)
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props5 = this.props,
            value = _props5.value,
            onChange = _props5.onChange,
            tagProps = _props5.tagProps,
            renderLayout = _props5.renderLayout,
            renderTag = _props5.renderTag,
            renderInput = _props5.renderInput,
            addKeys = _props5.addKeys,
            removeKeys = _props5.removeKeys,
            className = _props5.className,
            focusedClassName = _props5.focusedClassName,
            addOnBlur = _props5.addOnBlur,
            addOnPaste = _props5.addOnPaste,
            inputProps = _props5.inputProps,
            pasteSplit = _props5.pasteSplit,
            onlyUnique = _props5.onlyUnique,
            maxTags = _props5.maxTags,
            validationRegex = _props5.validationRegex,
            disabled = _props5.disabled,
            tagDisplayProp = _props5.tagDisplayProp,
            inputValue = _props5.inputValue,
            onChangeInput = _props5.onChangeInput,
            other = _objectWithoutProperties(_props5, ['value', 'onChange', 'tagProps', 'renderLayout', 'renderTag', 'renderInput', 'addKeys', 'removeKeys', 'className', 'focusedClassName', 'addOnBlur', 'addOnPaste', 'inputProps', 'pasteSplit', 'onlyUnique', 'maxTags', 'validationRegex', 'disabled', 'tagDisplayProp', 'inputValue', 'onChangeInput']);

        var isFocused = this.state.isFocused;


        if (isFocused) {
          className += ' ' + focusedClassName;
        }

        var tagComponents = value.map(function (tag, index) {
          return renderTag(_extends({
            key: index,
            tag: tag,
            onRemove: _this4.handleRemove.bind(_this4),
            disabled: disabled,
            getTagDisplayValue: _this4._getTagDisplayValue.bind(_this4)
          }, tagProps));
        });

        var inputComponent = renderInput(_extends({
          ref: function ref(r) {
            _this4.input = r;
          },
          value: this._tag(),
          onPaste: this.handlePaste.bind(this),
          onKeyDown: this.handleKeyDown.bind(this),
          onChange: this.handleChange.bind(this),
          onFocus: this.handleOnFocus.bind(this),
          onBlur: this.handleOnBlur.bind(this),
          addTag: this.addTag.bind(this)
        }, this.inputProps()));

        return _react2.default.createElement(
          'div',
          { ref: function ref(r) {
              _this4.div = r;
            }, onClick: this.handleClick.bind(this), className: className },
          renderLayout(tagComponents, inputComponent)
        );
      }
    }]);

    return TagsInput;
  }(_react2.default.Component);

  TagsInput.defaultProps = {
    className: 'react-tagsinput',
    focusedClassName: 'react-tagsinput--focused',
    addKeys: [9, 13],
    addOnBlur: false,
    addOnPaste: false,
    inputProps: {},
    removeKeys: [8],
    renderInput: defaultRenderInput,
    renderTag: defaultRenderTag,
    renderLayout: defaultRenderLayout,
    pasteSplit: defaultPasteSplit,
    tagProps: { className: 'react-tagsinput-tag', classNameRemove: 'react-tagsinput-remove' },
    onlyUnique: false,
    maxTags: -1,
    validationRegex: /.*/,
    disabled: false,
    tagDisplayProp: null,
    preventSubmit: true
  };
  exports.default = TagsInput;
  module.exports = exports['default'];
});
});

var ReactTagsInput = _commonjsHelpers.unwrapExports(reactTagsinput);

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  height: 100px;\n  padding: 10px;\n  overflow-y: scroll;\n  ", "\n  ", "\n"], ["\n  border: 1px solid ", ";\n  height: 100px;\n  padding: 10px;\n  overflow-y: scroll;\n  ", "\n  ", "\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  ", "\n  padding: 8.5px 20px;\n  border: 0px;\n  background-color: #f1f1f1;\n  :focus {\n    outline: none;\n  }\n"], ["\n  ", "\n  padding: 8.5px 20px;\n  border: 0px;\n  background-color: #f1f1f1;\n  :focus {\n    outline: none;\n  }\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  ", "\n  line-height: 100%;\n  font-stretch: 100%;\n  font-weight: 600;\n  color: #3b99fc;\n  padding: 10px 20px;\n  background-color: #e2f0ff;\n  display: inline-block;\n  word-break: break-all;\n"], ["\n  ", "\n  line-height: 100%;\n  font-stretch: 100%;\n  font-weight: 600;\n  color: #3b99fc;\n  padding: 10px 20px;\n  background-color: #e2f0ff;\n  display: inline-block;\n  word-break: break-all;\n"]),
    _templateObject4 = _babelHelpers.taggedTemplateLiteral(["\n  margin-left: 10px;\n  ::before {\n    content: \"\xD7\";\n    font-size: 21px;\n    font-weight: 400;\n    color: #333333;\n    vertical-align: -20%;\n    cursor: pointer;\n  }\n"], ["\n  margin-left: 10px;\n  ::before {\n    content: \"\xD7\";\n    font-size: 21px;\n    font-weight: 400;\n    color: #333333;\n    vertical-align: -20%;\n    cursor: pointer;\n  }\n"]);

var tagStyle = "\n  font-family: Source Sans Pro, sans-serif;\n  font-size: 14px;\n  border-radius: 17.5px;\n  margin: 0px 8px 5px 0px;\n";

var Wrapper = styled__default.div(_templateObject, function (_ref) {
  var error = _ref.error;
  return error ? "#f15555" : "#e5e5e5";
}, function (_ref2) {
  var focusOnClick = _ref2.focusOnClick;
  return focusOnClick && "cursor: text;";
}, function (_ref3) {
  var wrapperStyle = _ref3.wrapperStyle;
  return wrapperStyle;
});

var StyledInput = styled__default.input(_templateObject2, tagStyle);

var StyledSpan = styled__default.span(_templateObject3, tagStyle);

var Remove = styled__default.span(_templateObject4);

var renderDefaultTag = (function (_ref) {
  var tag = _ref.tag,
      key = _ref.key,
      disabled = _ref.disabled,
      onRemove = _ref.onRemove,
      classNameRemove = _ref.classNameRemove,
      getTagDisplayValue = _ref.getTagDisplayValue,
      props = _babelHelpers.objectWithoutProperties(_ref, ["tag", "key", "disabled", "onRemove", "classNameRemove", "getTagDisplayValue"]);
  return React__default.createElement(
    StyledSpan,
    _babelHelpers._extends({ key: key }, props),
    React__default.createElement(
      "span",
      null,
      getTagDisplayValue(tag)
    ),
    !disabled && React__default.createElement(Remove, { className: classNameRemove, onClick: function onClick() {
        return onRemove(key);
      } })
  );
});

var KEY_CODES = {
  COMMA: 188,
  ENTER: 13,
  SPACE: 32
};

var ANDROID_KEY_CODES = {
  COMMA: 44,
  SPACE: 32
};

var INPUT_FORMATS = {
  PHONE: "PHONE"
};

var SEPARATORS = [",", ";", ":", " ", "\n", "\r", "\t"];

var parser = new uaParser.Parser();

var _parser$getResult = parser.getResult(),
    os = _parser$getResult.os;

var asciiToKeyCode = function asciiToKeyCode() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var oldCode = arguments[1];

  var code = value.charCodeAt(value.length - 1);
  switch (code) {
    case ANDROID_KEY_CODES.COMMA:
      return KEY_CODES.COMMA;
    case ANDROID_KEY_CODES.SPACE:
      return KEY_CODES.SPACE;
    default:
      return oldCode;
  }
};

var TextInput = function TextInput(_ref) {
  var onChange = _ref.onChange,
      onKeyDown = _ref.onKeyDown,
      value = _ref.value,
      addTag = _ref.addTag,
      props = _babelHelpers.objectWithoutProperties(_ref, ["onChange", "onKeyDown", "value", "addTag"]);

  var handleKeyDown = function handleKeyDown(e) {
    if (os.name === "Android" && e.keyCode === 229) {
      try {
        var event = cloneDeep(e);
        setTimeout(function () {
          event.keyCode = asciiToKeyCode(event.target.value, event.oldCode);
          onKeyDown(event);
        }, 1);
      } catch (error) {
        onKeyDown(e);
      }
    } else {
      onKeyDown(e);
    }
  };
  return React__default.createElement(StyledInput, _babelHelpers._extends({
    type: "text",
    onChange: onChange,
    onKeyDown: handleKeyDown,
    value: value
  }, props));
};
var PhoneInput = function PhoneInput(_ref2) {
  var addTag = _ref2.addTag,
      props = _babelHelpers.objectWithoutProperties(_ref2, ["addTag"]);
  return React__default.createElement(number_format.NumberFormat, _babelHelpers._extends({
    customInput: TextInput,
    format: "(###) ###-####",
    type: "tel"
  }, props));
};
var renderDefaultInput = (function (format) {
  switch (format) {
    case INPUT_FORMATS.PHONE:
      return PhoneInput;
    default:
      return TextInput;
  }
});
TextInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TextInput"
};
PhoneInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PhoneInput"
};

var parser$1 = new uaParser.Parser();

var _parser$getResult$1 = parser$1.getResult(),
    os$1 = _parser$getResult$1.os;

/**
 * The TagsInput component
 * @param {String} name the name of input field
 * @param {[Object]} tags the array of tag value objects
 * @param {Function} onChange the function for handle tag value added or deleted
 * @param {Boolean} noLabel the flag that hide or not hide label component
 * @param {String} label the label text
 * @param {String} labelColor the color of label text
 * @param {String|Object} labelStyle the style of label component in css syntax or style object
 * @param {Boolean} isRequired the flag that show or not show required symbol (*)
 * @param {String|Number|Node} labelChildren the children of label component that render as a suffix of label
 * @param {Boolean} disabled the flag that disabled or enabled input field
 * @param {String} id the id of input field
 * @param {String|Node} error the error message
 * @param {String|Object} errorStyle the style of error component in css syntax or style object
 * @param {String|Object} wrapperStyle the style of input field in css syntax or style object
 * @param {Object} className the className of ReactTagsInput
 * @param {String} placeholder the text that describe tag input field
 * @param {Object} addKeys the object of add event key code
 * @param {Object} inputFormat the input component format (e.g. PHONE)
 * @param {Object} tagProps the object of tag component props
 * @param {Object} inputProps the object of input component props
 * @param {Object} focusOnClick the flag that enabled or disabled input focus on click wrapper
 * @param {Object} addOnBlur the flag that enabled or disabled add on input blur
 * @param {Object} addOnPaste the flag that enabled or disabled add on paste data to the input
 * @param {Object} pasteSeparators the array of separator for add on paste
 * @param {Object} renderInput the render input function for ReactTagsInput
 * @param {Object} renderTag the render tag function for ReactTagsInput
 */


var TagsInput = function (_Component) {
  _babelHelpers.inherits(TagsInput, _Component);

  function TagsInput() {
    var _ref;

    var _temp, _this, _ret;

    _babelHelpers.classCallCheck(this, TagsInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _babelHelpers.possibleConstructorReturn(this, (_ref = TagsInput.__proto__ || Object.getPrototypeOf(TagsInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (values) {
      var onChange = _this.props.onChange;

      var tags = values;
      if (os$1.name === "Android") {
        tags = values.map(function (value) {
          return value.replace(/,$/g, "").trim();
        });
      }
      onChange(tags);
    }, _this.focusInput = function () {
      var id = _this.props.id;

      try {
        document.getElementById(id).focus();
      } catch (err) {
        throw err;
      }
    }, _this.handlePasteSplit = function (values) {
      var _this$props = _this.props,
          pasteSeparators = _this$props.pasteSeparators,
          pasteFormat = _this$props.pasteFormat,
          pasteSplit = _this$props.pasteSplit;

      if (pasteSplit) {
        return pasteSplit(values, pasteSeparators, pasteFormat);
      }
      // eslint-disable-next-line no-useless-escape
      var telFormat = /^\((\d{3})\)\s(\d{3})\-(\d{4})$/g;
      if (telFormat.test(values)) return [values];
      var splited = values.split(new RegExp(pasteSeparators.join("|"))).map(function (value) {
        if (pasteFormat) return pasteFormat(value);
        return value.trim();
      });
      return splited;
    }, _temp), _babelHelpers.possibleConstructorReturn(_this, _ret);
  }

  _babelHelpers.createClass(TagsInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.focusInput();
      }, 300);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          name = _props.name,
          tags = _props.tags,
          noLabel = _props.noLabel,
          label = _props.label,
          labelColor = _props.labelColor,
          labelStyle = _props.labelStyle,
          isRequired = _props.isRequired,
          labelChildren = _props.labelChildren,
          disabled = _props.disabled,
          id = _props.id,
          error = _props.error,
          errorStyle = _props.errorStyle,
          wrapperStyle = _props.wrapperStyle,
          className = _props.className,
          placeholder = _props.placeholder,
          addKeys = _props.addKeys,
          inputFormat = _props.inputFormat,
          tagProps = _props.tagProps,
          inputProps = _props.inputProps,
          focusOnClick = _props.focusOnClick,
          addOnBlur = _props.addOnBlur,
          addOnPaste = _props.addOnPaste,
          renderInput = _props.renderInput,
          renderTag = _props.renderTag,
          omitKeys = _props.omitKeys,
          props = _babelHelpers.objectWithoutProperties(_props, ["name", "tags", "noLabel", "label", "labelColor", "labelStyle", "isRequired", "labelChildren", "disabled", "id", "error", "errorStyle", "wrapperStyle", "className", "placeholder", "addKeys", "inputFormat", "tagProps", "inputProps", "focusOnClick", "addOnBlur", "addOnPaste", "renderInput", "renderTag", "omitKeys"]);

      return React__default.createElement(
        sharedComponents.InputGroup,
        null,
        !noLabel && React__default.createElement(
          sharedComponents.StyledLabel,
          {
            textColor: labelColor,
            labelStyle: labelStyle,
            disabled: disabled },
          label,
          isRequired && React__default.createElement(
            sharedComponents.RedText,
            { disabled: disabled },
            " *"
          ),
          labelChildren
        ),
        React__default.createElement(
          Wrapper,
          {
            error: error,
            wrapperStyle: wrapperStyle,
            focusOnClick: focusOnClick,
            onClick: focusOnClick ? this.focusInput : null },
          React__default.createElement(ReactTagsInput, _babelHelpers._extends({
            className: className,
            value: tags,
            onChange: this.handleChange,
            renderInput: renderInput || renderDefaultInput(inputFormat),
            renderTag: renderTag || renderDefaultTag,
            addKeys: Object.values(_babelHelpers._extends({}, addKeys)),
            tagProps: tagProps,
            inputProps: _babelHelpers._extends({ id: id, name: name, placeholder: placeholder }, inputProps),
            disabled: disabled,
            addOnBlur: addOnBlur,
            addOnPaste: addOnPaste,
            pasteSplit: this.handlePasteSplit
          }, props))
        ),
        error && React__default.createElement(
          sharedComponents.ErrorMessage,
          { ErrorMessageStyle: errorStyle },
          error
        )
      );
    }
  }]);
  return TagsInput;
}(React.Component);

TagsInput.propTypes = {
  /** the name of input field */
  name: PropTypes$1.string.isRequired,
  /** the array of tag value */
  tags: PropTypes$1.arrayOf(PropTypes$1.string).isRequired,
  /** the function for handle tag value added or deleted */
  onChange: PropTypes$1.func.isRequired,
  /** the flag that hide or not hide label component */
  noLabel: PropTypes$1.bool,
  /** the label text */
  label: PropTypes$1.string,
  /** the color of label text */
  labelColor: PropTypes$1.string,
  /** the style of label component in css syntax or style object */
  labelStyle: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.object]),
  /** the flag that show or not show required symbol (*) */
  isRequired: PropTypes$1.bool,
  /** the children of label component that render as a suffix of label */
  labelChildren: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number, PropTypes$1.node]),
  /** the flag that disabled or enabled input field */
  disabled: PropTypes$1.bool,
  /** the id of input field */
  id: PropTypes$1.string,
  /** the error message */
  error: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.string]),
  /** the style of error component in css syntax or style object */
  errorStyle: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.object]),
  /** the style of input field in css syntax or style object */
  wrapperStyle: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.object]),
  /** the className of ReactTagsInput */
  className: PropTypes$1.string,
  /** the text that describe tag input field */
  placeholder: PropTypes$1.string,
  /** the object of add event key code */
  addKeys: PropTypes$1.objectOf(PropTypes$1.number),
  /** the input component format (e.g. PHONE) */
  inputFormat: PropTypes$1.oneOf(Object.values(INPUT_FORMATS)),
  /** the object of tag component props */
  tagProps: PropTypes$1.object,
  /** the object of input component props */
  inputProps: PropTypes$1.object,
  /** the flag that enabled or disabled input focus on click wrapper */
  focusOnClick: PropTypes$1.bool,
  /** the flag that enabled or disabled add on input blur */
  addOnBlur: PropTypes$1.bool,
  /** the flag that enabled or disabled add on paste data to the input */
  addOnPaste: PropTypes$1.bool,
  /** the array of separator for add on paste */
  pasteSeparators: PropTypes$1.arrayOf(PropTypes$1.string),
  /** the render input function for ReactTagsInput */
  renderInput: PropTypes$1.func,
  /** the render tag function for ReactTagsInput */
  renderTag: PropTypes$1.func,
  /** the function that parse pasted values to the format */
  pasteFormat: PropTypes$1.func,
  /** the pasteSplit function for cutomize paste split logic */
  pasteSplit: PropTypes$1.func
};

TagsInput.defaultProps = {
  id: "tagsinput-input",
  noLabel: false,
  label: "Tags Input",
  isRequired: false,
  disabled: false,
  placeholder: "",
  focusOnClick: true,
  addOnBlur: true,
  addOnPaste: true,
  pasteSeparators: SEPARATORS,
  addKeys: KEY_CODES
};
TagsInput.__docgenInfo = {
  "description": "The TagsInput component\n@param {String} name the name of input field\n@param {[Object]} tags the array of tag value objects\n@param {Function} onChange the function for handle tag value added or deleted\n@param {Boolean} noLabel the flag that hide or not hide label component\n@param {String} label the label text\n@param {String} labelColor the color of label text\n@param {String|Object} labelStyle the style of label component in css syntax or style object\n@param {Boolean} isRequired the flag that show or not show required symbol (*)\n@param {String|Number|Node} labelChildren the children of label component that render as a suffix of label\n@param {Boolean} disabled the flag that disabled or enabled input field\n@param {String} id the id of input field\n@param {String|Node} error the error message\n@param {String|Object} errorStyle the style of error component in css syntax or style object\n@param {String|Object} wrapperStyle the style of input field in css syntax or style object\n@param {Object} className the className of ReactTagsInput\n@param {String} placeholder the text that describe tag input field\n@param {Object} addKeys the object of add event key code\n@param {Object} inputFormat the input component format (e.g. PHONE)\n@param {Object} tagProps the object of tag component props\n@param {Object} inputProps the object of input component props\n@param {Object} focusOnClick the flag that enabled or disabled input focus on click wrapper\n@param {Object} addOnBlur the flag that enabled or disabled add on input blur\n@param {Object} addOnPaste the flag that enabled or disabled add on paste data to the input\n@param {Object} pasteSeparators the array of separator for add on paste\n@param {Object} renderInput the render input function for ReactTagsInput\n@param {Object} renderTag the render tag function for ReactTagsInput",
  "methods": [{
    "name": "handleChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "values",
      "type": null
    }],
    "returns": null
  }, {
    "name": "focusInput",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handlePasteSplit",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "values",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "TagsInput",
  "props": {
    "id": {
      "defaultValue": {
        "value": "\"tagsinput-input\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "the id of input field"
    },
    "noLabel": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "the flag that hide or not hide label component"
    },
    "label": {
      "defaultValue": {
        "value": "\"Tags Input\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "the label text"
    },
    "isRequired": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "the flag that show or not show required symbol (*)"
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "the flag that disabled or enabled input field"
    },
    "placeholder": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "the text that describe tag input field"
    },
    "focusOnClick": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "the flag that enabled or disabled input focus on click wrapper"
    },
    "addOnBlur": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "the flag that enabled or disabled add on input blur"
    },
    "addOnPaste": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "the flag that enabled or disabled add on paste data to the input"
    },
    "pasteSeparators": {
      "defaultValue": {
        "value": "SEPARATORS",
        "computed": true
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": "the array of separator for add on paste"
    },
    "addKeys": {
      "defaultValue": {
        "value": "KEY_CODES",
        "computed": true
      },
      "type": {
        "name": "objectOf",
        "value": {
          "name": "number"
        }
      },
      "required": false,
      "description": "the object of add event key code"
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "the name of input field"
    },
    "tags": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": true,
      "description": "the array of tag value"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "the function for handle tag value added or deleted"
    },
    "labelColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "the color of label text"
    },
    "labelStyle": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "the style of label component in css syntax or style object"
    },
    "labelChildren": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }, {
          "name": "node"
        }]
      },
      "required": false,
      "description": "the children of label component that render as a suffix of label"
    },
    "error": {
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "the error message"
    },
    "errorStyle": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "the style of error component in css syntax or style object"
    },
    "wrapperStyle": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "the style of input field in css syntax or style object"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "the className of ReactTagsInput"
    },
    "inputFormat": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "Object.values(INPUT_FORMATS)"
      },
      "required": false,
      "description": "the input component format (e.g. PHONE)"
    },
    "tagProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "the object of tag component props"
    },
    "inputProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "the object of input component props"
    },
    "renderInput": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "the render input function for ReactTagsInput"
    },
    "renderTag": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "the render tag function for ReactTagsInput"
    },
    "pasteFormat": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "the function that parse pasted values to the format"
    },
    "pasteSplit": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "the pasteSplit function for cutomize paste split logic"
    }
  }
};

module.exports = TagsInput;
//# sourceMappingURL=tags.js.map
